var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16589 2.69678C1.16589 2.48967 1.32495 2.32178 1.52116 2.32178L5.31063 2.32178C5.50684 2.32178 5.66589 2.48967 5.66589 2.69678C5.66589 2.90388 5.50684 3.07178 5.31063 3.07178L1.52116 3.07178C1.32495 3.07178 1.16589 2.90388 1.16589 2.69678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16589 9.69678C1.16589 9.48967 1.32495 9.32178 1.52116 9.32178L5.31063 9.32178C5.50684 9.32178 5.66589 9.48967 5.66589 9.69678C5.66589 9.90388 5.50684 10.0718 5.31063 10.0718L1.52116 10.0718C1.32495 10.0718 1.16589 9.90388 1.16589 9.69678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91589 6.19678C6.91589 5.98967 7.07495 5.82178 7.27116 5.82178L11.0606 5.82178C11.2568 5.82178 11.4159 5.98967 11.4159 6.19678C11.4159 6.40388 11.2568 6.57178 11.0606 6.57178L7.27116 6.57178C7.07495 6.57178 6.91589 6.40388 6.91589 6.19678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91589 2.69678C8.91589 2.48967 9.10244 2.32178 9.33256 2.32178L10.9992 2.32178C11.2293 2.32178 11.4159 2.48967 11.4159 2.69678C11.4159 2.90388 11.2293 3.07178 10.9992 3.07178L9.33256 3.07178C9.10244 3.07178 8.91589 2.90388 8.91589 2.69678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91589 9.69678C8.91589 9.48967 9.10244 9.32178 9.33256 9.32178L10.9992 9.32178C11.2293 9.32178 11.4159 9.48967 11.4159 9.69678C11.4159 9.90388 11.2293 10.0718 10.9992 10.0718L9.33256 10.0718C9.10244 10.0718 8.91589 9.90388 8.91589 9.69678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16589 6.19678C1.16589 5.98967 1.35244 5.82178 1.58256 5.82178L3.24923 5.82178C3.47935 5.82178 3.66589 5.98967 3.66589 6.19678C3.66589 6.40388 3.47935 6.57178 3.24923 6.57178L1.58256 6.57178C1.35244 6.57178 1.16589 6.40388 1.16589 6.19678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29089 1.19678C7.46247 1.19678 6.79089 1.86835 6.79089 2.69678C6.79089 3.5252 7.46247 4.19678 8.29089 4.19678C9.11932 4.19678 9.79089 3.5252 9.79089 2.69678C9.79089 1.86835 9.11932 1.19678 8.29089 1.19678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29089 8.19678C7.46247 8.19678 6.79089 8.86835 6.79089 9.69678C6.79089 10.5252 7.46247 11.1968 8.29089 11.1968C9.11932 11.1968 9.79089 10.5252 9.79089 9.69678C9.79089 8.86835 9.11932 8.19678 8.29089 8.19678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29089 4.69678C3.46247 4.69678 2.79089 5.36835 2.79089 6.19678C2.79089 7.0252 3.46247 7.69678 4.29089 7.69678C5.11932 7.69678 5.79089 7.0252 5.79089 6.19678C5.79089 5.36835 5.11932 4.69678 4.29089 4.69678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.290894 0.196777)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSelected);
export default __webpack_public_path__ + "static/media/MoreSelected.e6bbea01e8f28618a82cff5f57e10725.svg";
export { ForwardRef as ReactComponent };